import { PurchasingRepository } from '@Purchasing/Data/Repository/PurchasingRepository'
import {
    FetchPurchaseProcessesParams,
    PaginatedPurchaseProcesses,
} from '@Purchasing/Data/DataSource/API/Entity/PurchaseProcess'

export interface GetPurchaseProcesses {
    execute(
        params: FetchPurchaseProcessesParams
    ): Promise<PaginatedPurchaseProcesses>
    getSource(): string
}

export class GetPurchaseProcessesUseCase implements GetPurchaseProcesses {
    constructor(private repository: PurchasingRepository) {}
    async execute(
        params: FetchPurchaseProcessesParams
    ): Promise<PaginatedPurchaseProcesses> {
        return this.repository.getProcesses(params)
    }
    getSource(): string {
        return this.repository.dataSource.getSource()
    }
}
